import(/* webpackMode: "eager" */ "/vercel/path0/src/app/artisan-dashboard/page.tsx");
